import { SignIn, SignUp } from "@clerk/clerk-react";
import { useLocation } from "react-router-dom";

import { BRAND_LANDING_PAGE_LINK } from "constants/influencer";
import InfluencerLayout from "features/Auth/Layout/Influencer";
import { AuthAction } from "features/Auth/schema";

interface Props {
  email?: string | null;
  action: AuthAction;
}

const BrandOnboardingSignup = ({ email, action }: Props) => {
  const location = useLocation();
  const redirectUrl = `/brands${location.search}`;
  const signInUrl = `/brands/sign-in${location.search}`;
  const signUpUrl = `/brands/sign-up${location.search}`;

  return (
    <InfluencerLayout isBrand>
      {action === AuthAction.SIGN_UP && (
        <SignUp
          initialValues={{
            emailAddress: email || "",
          }}
          signInUrl={signInUrl}
          afterSignUpUrl={redirectUrl}
          afterSignInUrl={redirectUrl}
          appearance={{
            layout: {
              logoLinkUrl: BRAND_LANDING_PAGE_LINK,
            },
          }}
        />
      )}
      {action === AuthAction.SIGN_IN && (
        <SignIn
          initialValues={{
            emailAddress: email || "",
          }}
          signUpUrl={signUpUrl}
          afterSignUpUrl={redirectUrl}
          afterSignInUrl={redirectUrl}
          appearance={{
            layout: {
              logoLinkUrl: BRAND_LANDING_PAGE_LINK,
            },
          }}
        />
      )}
    </InfluencerLayout>
  );
};

export default BrandOnboardingSignup;
